import {Component} from '@angular/core';
import {NavigationTriggerService} from '@app/services/admin/navigation-trigger.service';

@Component({
  selector: 'app-proxyadvisor-landing',
  templateUrl: './proxyadvisor-landing.component.html',
  styleUrls: ['./proxyadvisor-landing.component.css']
})
export class ProxyAdvisorLandingComponent {
  isChild = true;

  constructor(private navigationTriggerService: NavigationTriggerService) {

  }

  ngOnInit() {
    this.navigationTriggerService.setSubMenu(false);
  }
}
